import React from 'react';

type Props = {
    academicInterests: string[];
};

export const AcademicInterestsCard: React.FC<Props> = ({ academicInterests }) => {
    return (
        <div className="profile-card academics">
            <div className="title-container">
                <h2 className="title">Academic Interests</h2>
                <div className="list">
                    {academicInterests.map((interest: string, index: number) => (
                        <p className="list-item" key={`academic-interest-${index}`}>
                            {interest}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};
